import { MerchantCatalogUploadsApi } from '../openapi';
import { config } from './config';

export const CatalogUploadClient = new MerchantCatalogUploadsApi(config);
